import {
	GetCurrentPulseMetaResponse,
	GetCustomFactorResponse,
	GetEngagementNotificationResponse,
	GetEngagementQuestionResponse,
} from "@performyard/service-contracts";

import request from "./internal-base-request";

export const getEngagementNotification = async (): Promise<GetEngagementNotificationResponse | null> => {
	const [response] = await request<GetEngagementNotificationResponse | null>(`/v1/engagement/notification`);
	return response;
};

export const dismissEngagementNotification = async () => {
	const [response] = await request(`/v1/engagement/notification`, {
		method: "DELETE",
	});
	return response;
};

export const sendManualReminders = async () => {
	const [response] = await request(`/v1/engagement/send_manual_reminders`, {
		body: JSON.stringify({}),
		method: "POST",
	});
	return response;
};

export const getQuestionById = async (questionId: string) => {
	const [question] = await request<GetEngagementQuestionResponse>(`/v1/engagement/questions/${questionId}`, {
		method: "GET",
	});
	return question;
};

export const manuallyCloseEngagementSurvey = async () => {
	const [response] = await request(`/v1/engagement/manually_close_survey`, {
		body: JSON.stringify({}),
		method: "POST",
	});
	return response;
};

export const getCurrentPulseMeta = async (): Promise<GetCurrentPulseMetaResponse> => {
	const [response] = await request<GetCurrentPulseMetaResponse>(`/v1/engagement/current-pulse/meta`, {
		method: "GET",
	});
	return response;
};

export const getCustomFactors = async (): Promise<GetCustomFactorResponse[]> => {
	const [response] = await request<GetCustomFactorResponse[]>(`/v1/engagement/custom-factors`, {
		method: "GET",
	});
	return response;
};

export const getCustomFactorsIncludedInSatisfaction = async (): Promise<GetCustomFactorResponse[]> => {
	const [response] = await request<GetCustomFactorResponse[]>(
		`/v1/engagement/custom-factors-included-in-satisfaction`,
		{
			method: "GET",
		}
	);
	return response;
};
